import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Release\GetReleaseByIdController::__invoke
* @see app/Http/Controllers/Release/GetReleaseByIdController.php
* @route '/api/sa-management/release/{release}'
*/
const GetReleaseByIdController = (args: { release: string | { id: string } } | [release: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetReleaseByIdController.url(args, options),
    method: 'get',
})

GetReleaseByIdController.definition = {
    methods: ["get","head"],
    url: '/api/sa-management/release/{release}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Release\GetReleaseByIdController::__invoke
* @see app/Http/Controllers/Release/GetReleaseByIdController.php
* @route '/api/sa-management/release/{release}'
*/
GetReleaseByIdController.url = (args: { release: string | { id: string } } | [release: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { release: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { release: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            release: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        release: typeof args.release === 'object'
        ? args.release.id
        : args.release,
    }

    return GetReleaseByIdController.definition.url
            .replace('{release}', parsedArgs.release.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Release\GetReleaseByIdController::__invoke
* @see app/Http/Controllers/Release/GetReleaseByIdController.php
* @route '/api/sa-management/release/{release}'
*/
GetReleaseByIdController.get = (args: { release: string | { id: string } } | [release: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetReleaseByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Release\GetReleaseByIdController::__invoke
* @see app/Http/Controllers/Release/GetReleaseByIdController.php
* @route '/api/sa-management/release/{release}'
*/
GetReleaseByIdController.head = (args: { release: string | { id: string } } | [release: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetReleaseByIdController.url(args, options),
    method: 'head',
})

export default GetReleaseByIdController